import React from 'react';
import { Star } from '@mui/icons-material';
import { ListItem, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { style } from './style';

type StatusItemProps = {
  status: string,
}

// todo: from translate
export const StatusItem = ({ status }: StatusItemProps):JSX.Element => {
  return (
    <ListItem>
      <Box sx={ style.boxContainer.sx }>
        <Box sx={ style.boxContainer.boxRow.sx  }>
          <Star />
        </Box>
        <Typography variant={ style.boxContainer.Typography.variant }>
          Status
        </Typography>
        <Typography
          variant={ style.boxContainer.Typography.variant }
          color={ style.boxContainer.Typography.text }
        >
          {status}
        </Typography>
      </Box>
    </ListItem>
  );
};
